module.exports = __webpack_public_path__ + "img/白眼.2de3b3a6.gif";